export const kebabCase = (word) => word.toLowerCase().replace(/[^\w\s]/gi, '').trim().replace(/ /g, '-');